module.exports = __webpack_public_path__ + "dist/img/yan-doc.7be7601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yan-doc.jpg
// module id = CUxH
// module chunks = 1